const skipSectionLinks = document.querySelectorAll(".skip-section-link");
skipSectionLinks.forEach((skipSectionLink: HTMLLinkElement) => {
    const section = skipSectionLink.closest("section");
    if (!section) {
        return;
    }

    skipSectionLink.addEventListener("click", (e) => {
        e.preventDefault();
        window.scrollTo({
            top: section.offsetTop - section.scrollTop + section.offsetHeight,
            behavior: "smooth",
        });

        const nextFocusable = getNextFocusableElement(section);
        if (nextFocusable) {
            (nextFocusable as HTMLElement).focus();
        }
    });
});

// css selector for focusable elements
const focusableSelectors = ['a[href]:not([tabindex="-1"])', 'button:not([disabled]):not([tabindex="-1"])'].join(",");

// find next focusable element
function getNextFocusableElement(section: HTMLElement) {
    let next = section.nextElementSibling;
    while (next) {
        if (next.matches && next.matches(focusableSelectors)) {
            return next;
        }
        // check for focusable descendants
        const focusableDescendant = next.querySelector && next.querySelector(focusableSelectors);
        if (focusableDescendant) {
            return focusableDescendant;
        }
        next = next.nextElementSibling;
    }
    return null;
}
